import React from 'react';
import classNames from 'classnames';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';

import './BannerWrapper.styles.scss';

type BannerWrapperProps = {
  className?: string;
  isVisible?: boolean;
  color?: ColorVariants;
  onClick?: () => void;
  onClose?: () => void;
};

const BannerWrapper: React.FC<BannerWrapperProps> = (props) => {
  const {
    className,
    children,
    isVisible,
    color = COLOR_VARIANT.PRIMARY,
    onClick,
    onClose,
  } = props;

  const classes = classNames(
    'banner-wrapper',
    'toast-banner',
    className,
    color,
    {
      clickable: !!onClick,
      visible: isVisible,
    },
  );

  return (
    <div className={classes} onClick={onClick}>
      {children}

      {onClose && (
        <Button
          variant="icon"
          aria-label="Close"
          className="close"
          icon={XIcon}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />
      )}
    </div>
  );
};

export default BannerWrapper;
